import React from 'react';
import { useParams } from 'react-router-dom';

import styled from '@emotion/styled';

import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { TableComponent } from '../../components/TableCom';
import { ModalProvider } from '../../context/ModalContext';
import { TableRefreshProvider } from '../../context/TableRefreshContext';
import CargoDetails from '../../sections/dashboard/home/CargoDetails';

const path = [
  {
    name: 'Packages Within',
    link: '/package-within',
  },
  {
    name: 'High Value',
    link: '/high-value',
  },
  {
    name: 'Withheld',
    link: '/withheld',
  },
];

const Withheld = () => {
  const { airbillId, airbillNumber } = useParams();

  console.log('airbillId', airbillId);
  return (
    <TableRefreshProvider>
      <ModalProvider>
        <Container>
          <TableLabel>{`Package List - Airwaybill ${airbillNumber}`}</TableLabel>
          <TableComponent
            rigthRevealComponent={CargoDetails}
            tableLabel={
              <BreadCrumbs
                pathData={path}
                backPagePath="/"
                pathId={`${airbillNumber}/${airbillId}`}
              />
            }
            tableBaseUrl={`general-service/v1/cargos/${airbillId}/packages?state=WITHHELD`}
            hasQueryString={true}
            tableHeader={[
              'packageId',
              'name',
              'customerEmail',
              'customerPhoneNumber',
              'status',
            ]}
            mappingData={{
              packageId: 'Package ID',
              name: 'Name',
              customerEmail: 'Customer Email',
              customerPhoneNumber: 'Customer Phone',
              status: 'Status',
            }}
          />
        </Container>
      </ModalProvider>
    </TableRefreshProvider>
  );
};

export default Withheld;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const TableLabel = styled.div`
  font-weight: 700;
  font-size: 1.25rem;
`;
